<!-- 
Busy indicator for tables.
-->
<template>
  <div style="position: relative; top: 45px; height: 5px;">
    <v-progress-linear 
      v-if="show" color="primary" height="5" indeterminate 
      class="ma-0"
    />
  </div>
</template>

<script>
export default {
  props: {
    show: {
      default: false,
      type: Boolean
    }
  }
};
</script>
